export const GET_LIVE_SHEET_REQUEST = 'GET_LIVE_SHEET_REQUEST';
export const GET_LIVE_SHEET_SUCCESS = 'GET_LIVE_SHEET_SUCCESS';
export const GET_LIVE_SHEET_FAILURE = 'GET_LIVE_SHEET_FAILURE';
export const POST_GOOGLE_OAUTH2_REQUEST = 'POST_GOOGLE_OAUTH2_REQUEST';
export const POST_GOOGLE_OAUTH2_SUCCESS = 'POST_GOOGLE_OAUTH2_SUCCESS';
export const POST_GOOGLE_OAUTH2_FAILURE = 'POST_GOOGLE_OAUTH2_FAILURE';
export const POST_LIVE_SHEET_ENABLE_REQUEST = 'POST_LIVE_SHEET_ENABLE_REQUEST';
export const POST_LIVE_SHEET_ENABLE_SUCCESS = 'POST_LIVE_SHEET_ENABLE_SUCCESS';
export const POST_LIVE_SHEET_ENABLE_FAILURE = 'POST_LIVE_SHEET_ENABLE_FAILURE';
export const POST_LIVE_SHEET_DISABLE_REQUEST = 'POST_LIVE_SHEET_DISABLE_REQUEST';
export const POST_LIVE_SHEET_DISABLE_SUCCESS = 'POST_LIVE_SHEET_DISABLE_SUCCESS';
export const POST_LIVE_SHEET_DISABLE_FAILURE = 'POST_LIVE_SHEET_DISABLE_FAILURE';
export const POST_LIVE_SHEET_SYNC_REQUEST = 'POST_LIVE_SHEET_SYNC_REQUEST';
export const POST_LIVE_SHEET_SYNC_SUCCESS = 'POST_LIVE_SHEET_SYNC_SUCCESS';
export const POST_LIVE_SHEET_SYNC_FAILURE = 'POST_LIVE_SHEET_SYNC_FAILURE';
